export const tileDesktopLayout = '@container (min-width: 620px)'
